import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import {
    NgbActiveModal,
    NgbModule,
    NgbNavModule,
    NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { IconModule } from "@visurel/iconify-angular";
import { TranslateModule } from "@ngx-translate/core";
import { HttpClientModule } from "@angular/common/http";
import { NgApexchartsModule } from "ng-apexcharts";
import { ClipboardModule } from "ngx-clipboard";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxSmarterplanCoreModule } from "@smarterplan/ngx-smarterplan-core";
import { NgScrollbarModule } from "ngx-scrollbar";
import { SearchPipe } from "../pipes/search.pipe";
import { ErrorComponent } from "../components/error/error.component";
import { SafeUrlPipe } from "../pipes/safe-url.pipe";
import { AddFeatureComponent } from "../components/add-feature/add-feature.component";
import { FormFeatureComponent } from "../components/form-feature/form-feature.component";
import { CarouselFullscreenComponent } from "../components/carousel-fullscreen/carousel-fullscreen.component";
import { VideoFullscreenComponent } from "../components/video-fullscreen/video-fullscreen.component";
import { BatchEditFeatureComponent } from "../components/batch-edit/batch-edit-feature/batch-edit-feature.component";
import { BatchEditTagComponent } from "../components/batch-edit/batch-edit-tag/batch-edit-tag.component";
import { BatchEditItemListComponent } from "../components/batch-edit/batch-edit-item-list/batch-edit-item-list.component";
import { FormAttachmentComponent } from "../components/form-attachment/form-attachment.component";
import { ZoomCanvasComponent } from "../zoom/components/zoom-canvas/zoom-canvas.component";
import { AudioComponent } from "../components/audio/audio.component";
import { PdfModalComponent } from "../components/pdf-modal/pdf-modal.component";
import { ShorterTextPipe } from "../pipes/shorter-text.pipe";
import { SlideButtonComponent } from "../museum/components/slide-button/slide-button.component";
import { MuseumLoaderComponent } from "../museum/components/museum-loader/museum-loader.component";
import * as config from "../../assets/json-config/museumdev.json";
import { FeatureSortPipe } from "../pipes/feature-sort.pipe";
import { MuseumFeatureCardComponent } from "../museum/components/museum-lateral-menu/museum-feature-card/museum-feature-card.component";
import { MuseumHeaderComponent } from "../museum/components/museum-layout/museum-header/museum-header.component";
import { MuseumUserMenuComponent } from "../museum/components/museum-layout/museum-header/museum-user-menu/museum-user-menu.component";
import { NavigationBarComponent } from "../museum/components/museum-layout/navigation-bar/navigation-bar.component";
import { CacheUsernameFromIdPipe } from "../pipes/username-from-id.pipe";
import { OptionsMenuComponent } from "../museum/components/museum-lateral-menu/museum-feature-card/options-menu/options-menu.component";

@NgModule({
    imports: [
        CommonModule,
        NgbNavModule,
        IconModule,
        NgbModule,
        NgSelectModule,
        NgbTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        HttpClientModule,
        TranslateModule,
        NgApexchartsModule,
        ClipboardModule,
        PdfViewerModule,
        NgxSmarterplanCoreModule.forRoot({ my_config: config }),
        NgScrollbarModule,
    ],
    declarations: [
        // pipes
        SearchPipe,
        SafeUrlPipe,
        ShorterTextPipe,
        FeatureSortPipe,
        CacheUsernameFromIdPipe,
        // components
        ErrorComponent,
        AddFeatureComponent,
        FormFeatureComponent,
        CarouselFullscreenComponent,
        VideoFullscreenComponent,
        BatchEditFeatureComponent,
        BatchEditTagComponent,
        BatchEditItemListComponent,
        FormAttachmentComponent,
        ZoomCanvasComponent,
        AudioComponent,
        PdfModalComponent,
        SlideButtonComponent,
        MuseumLoaderComponent,
        MuseumFeatureCardComponent,
        MuseumHeaderComponent,
        MuseumUserMenuComponent,
        NavigationBarComponent,
        OptionsMenuComponent,
    ],
    exports: [
        // ---Modules
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        RouterModule,
        NgbTooltipModule,
        NgbNavModule,
        IconModule,
        NgbModule,
        TranslateModule,
        NgApexchartsModule,
        ClipboardModule,
        PdfViewerModule,
        NgxSmarterplanCoreModule,

        // ---Pipes
        SearchPipe,
        SafeUrlPipe,
        ShorterTextPipe,
        FeatureSortPipe,
        CacheUsernameFromIdPipe,

        // ---Components
        ErrorComponent,
        AddFeatureComponent,
        FormFeatureComponent,
        CarouselFullscreenComponent,
        VideoFullscreenComponent,
        BatchEditFeatureComponent,
        BatchEditTagComponent,
        BatchEditItemListComponent,
        FormAttachmentComponent,
        ZoomCanvasComponent,
        AudioComponent,
        PdfModalComponent,
        SlideButtonComponent,
        MuseumLoaderComponent,
        MuseumFeatureCardComponent,
        MuseumHeaderComponent,
        MuseumUserMenuComponent,
        NavigationBarComponent,
        OptionsMenuComponent,
    ],
    providers: [NgbActiveModal],
})
export class SharedModule { }
